'use strict';

import angular from 'angular';

export default angular.module('observatoireApp')
  .service('ForumService', ['$http', function($http) {
    const BASE = '/api/forum';

    function toDate(v) {
      if (!v) return null;
      if (Array.isArray(v) && v.length >= 3) {
        var d = new Date(v[0], v[1] - 1, v[2]);
        if (v.length >= 6) d.setHours(v[3] || 0, v[4] || 0, v[5] || 0);
        return d;
      }
      return new Date(v);
    }

    function fixPost(p) {
      if (!p) return p;
      p.createdAt = toDate(p.createdAt);
      if (p.replies) p.replies.forEach(fixReply);
      return p;
    }

    function fixReply(r) {
      if (r) r.createdAt = toDate(r.createdAt);
      return r;
    }

    this.getPosts = function(categorie) {
      var params = categorie ? { params: { categorie: categorie } } : {};
      return $http.get(BASE + '/posts', params).then(function(r) {
        return (r.data || []).map(fixPost);
      });
    };

    this.getPost = function(id) {
      return $http.get(BASE + '/posts/' + id).then(function(r) { return fixPost(r.data); });
    };

    this.createPost = function(data) {
      return $http.post(BASE + '/posts', data).then(function(r) { return fixPost(r.data); });
    };

    this.addReply = function(postId, data) {
      return $http.post(BASE + '/posts/' + postId + '/replies', data).then(function(r) { return fixReply(r.data); });
    };

    this.votePost = function(postId, username, type) {
      return $http.post(BASE + '/posts/' + postId + '/vote', { username: username, type: type }).then(function(r) { return r.data; });
    };

    this.voteReply = function(replyId, username, type) {
      return $http.post(BASE + '/replies/' + replyId + '/vote', { username: username, type: type }).then(function(r) { return r.data; });
    };

    this.deletePost = function(postId, auteur) {
      return $http({ method: 'DELETE', url: BASE + '/posts/' + postId, data: { auteur: auteur }, headers: { 'Content-Type': 'application/json' } });
    };

    this.deleteReply = function(replyId, auteur) {
      return $http({ method: 'DELETE', url: BASE + '/replies/' + replyId, data: { auteur: auteur }, headers: { 'Content-Type': 'application/json' } });
    };
  }]);
